<div class="card h-100">
  <div class="card-body">
    <div class="d-flex flex-row">
      <div class="h5">
        <a [routerLink]="'/user/' + alert._user._id">
          <img class="img-30 img-rounded" [src]="alert._user.image || profilePics.default" alt=""
            data-bs-toggle="tooltip" data-placement="top" [title]="alert._user.firstName + ' ' + alert._user.lastName">
        </a>
        {{alert.name}}
      </div>
      <div class="ms-auto">
        <button class="btn btn-sm btn-outline-primary" (click)="runAlertQuery(alert)"
          data-bs-toggle="tooltip" data-placement="top" title="Run alert's query in Search">
          <i class="fa fa-search"></i>
          <span class="d-none d-md-inline-block ms-1">Search</span>
        </button>
        @if (auth.isAdmin || auth.currentUser._id === alert._user._id || iAmParticipant || canEditAnyAlert) {
          <button
            class="btn btn-sm btn-primary ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-alert-modal" (click)="toggleEditAlertModal(alert)">
            <i class="fa fa-pencil"></i>
          </button>
        }
        @if (auth.isAdmin || auth.currentUser._id === alert._user._id || canEditAnyAlert) {
          <app-delete-btn (click)="deleteAlert(alert)"></app-delete-btn>
        }
      </div>
    </div>
    <div class="d-flex flex-column">
      <app-alert-query [alert]="alert"></app-alert-query>
    </div>
    @if (alert.status === 'off') {
      <div class="mt-1">
        Status: <span class="badge badge-warning">{{alert.status.toUpperCase()}}</span>
      </div>
    }
    <div class="mt-2">
      <i class="fa fa-envelope-o"></i> Sent to:
      @for (user of alert._users; track user._id) {
        <span>
          <a class="me-2" [routerLink]="'/user/' + user._id">
            <img class="img-25 img-rounded" [src]="user.image || profilePics.default" alt=""
              data-bs-toggle="tooltip" data-placement="top" [title]="user.firstName + ' ' + user.lastName">
          </a>
        </span>
      }
    </div>
    <div class="d-flex flex-row justify-content-end text-muted">
      <small>
        added on {{alert.created_at | date}}
        @if (alert.updated_at) {
          <i class="fa fa-clock-o cursor-pointer" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="updated on {{alert.updated_at | date}}"></i>
        }
      </small>
    </div>
  </div>
</div>

@if (isEditAlertModalVisible) {
  <app-edit-alert-modal [alert]="alert" [commissions]="commissions"></app-edit-alert-modal>
}